/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Map_LabelInputs */

const en_welcome_map_label = /** @type {(inputs: Welcome_Map_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting map`)
};

const fr_welcome_map_label = /** @type {(inputs: Welcome_Map_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de démarrage`)
};

const ms_sg2_welcome_map_label = /** @type {(inputs: Welcome_Map_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta permulaan`)
};

/**
* | output |
* | --- |
* | "Starting map" |
*
* @param {Welcome_Map_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_map_label = /** @type {((inputs?: Welcome_Map_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Map_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_map_label(inputs)
	if (locale === "fr") return fr_welcome_map_label(inputs)
	return ms_sg2_welcome_map_label(inputs)
});